import { css } from 'styled-components';

export const resetButtonStyles = css`
  all: unset;
  appearance: none;
  display: block;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
`;

export const resetListStyles = css`
  margin: 0;
  padding: 0;
  list-style: none;

  border: 0;
  background: none;
  font-size: inherit;
  font-family: inherit;
  list-style-position: outside;
`;

export const resetLinkStyles = css`
  color: inherit;
  text-decoration: none;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: inherit;
    text-decoration: none;
    outline: none;
  }
`;
